import {
  CheckCircleOutlineRounded,
  ErrorOutlineRounded,
  HourglassEmpty,
} from '@material-ui/icons';

import { useSFStockoutItemChip } from './hooks';

import makeClasses from './SFStockoutItemChip.style';
import type { ChipMode } from './SFStockoutItemChip.const';

const ICON_BY_MODE: Record<ChipMode, React.ComponentType> = {
  stockout: ErrorOutlineRounded,
  replacement: CheckCircleOutlineRounded,
  options: HourglassEmpty,
};

export function SFStockoutItemChip(props: Props) {
  const { size = 'regular', mode } = props;

  const { lang } = useSFStockoutItemChip({ mode });

  const TheIcon = ICON_BY_MODE[mode];

  const _classes = makeClasses({ size });

  return (
    <div
      role='status'
      aria-live='polite'
      aria-label='sf-stockout-item-chip'
      data-mode={mode}
      className={_classes.root}
    >
      <TheIcon aria-label='icon' />
      <span aria-label='label'>{lang.label}</span>
    </div>
  );
}

interface Props {
  // regular as default
  size?: 'small' | 'regular';
  mode: ChipMode;
}
